import { gql } from "graphql-tag"

const typeMixProduct = gql`
  type MixProduct {
    productId: Int
    description: String
    systemId: Int
    creationDate: String
    creationUser: String
    modificationDate: String
    modificationUser: String
    status: String
    sysId: ID
    systemVersion: Int
  }

  type MixCollection {
    sysId: Int
    description: String
  }

  type MixColor {
    color: String
    colorCode1: String
    colorCode2: String
    colorCode3: String
    colorCode4: String
    hbw: Float
    rcolor: Int
    gcolor: Int
    bcolor: Int
    sysId: Int
  }

  type MixArticle {
    sku: String
    title: String
    articleMainGroup: ArticleMainGroup
    articleGroup: ArticleGroup
    baseColor: String
    productRef: ProductRef
    attributes: [JSONObject]
    amount: Float
    contents: String
    container: String
    status: String
    price: ListPrice
    availability: String
    packageUnitPerCarton: String
    packageUnitPerPallet: String
    containerPerPallet: Float
    amountBilling: String
    sellableInDecimals: Boolean
    searchTermThree: String
    searchTermFour: String
  }

  type MixInventory {
    branchNr: String
    lagSchl: String
    stockNr: String
    layQuantity: Float
    resQuantity: Float
    bestQuantity: Float
    minBest: Float
  }

  type MixProducts {
    total: Int
    items: [MixProduct]
  }

  type MixCollections {
    total: Int
    items: [MixCollection]
  }

  type MixColors {
    total: Int
    items: [MixColor]
  }

  type MixArticles {
    total: Int
    items: [MixArticle]
  }

  type Query {
    mixArticles(
      productId: ID!
      collectionId: ID!
      colorId: ID!
      branchId: ID
      customerNumber: String
    ): MixArticles
    mixColors(productId: ID!, collectionId: ID!): MixColors
    allMixCollections: MixCollections
    allMixProducts: MixProducts
  }
`

export { typeMixProduct }

export default typeMixProduct
